import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    realtime: {
      airt: undefined, // 空气温度
      airh: undefined, // 空气湿度
      co2: undefined, // 二氧化碳浓度
      illu: undefined, // 光照强度
      par: undefined, // 光合辐照
      soilt: undefined,
      soilh: undefined,
      soilec: undefined,
      soilph: undefined,
    },
  },
  mutations: {
    realtime(state, val) {
      Object.assign(state.realtime, val)
    }
  },
  getters: {
    realtime(state) {
      return state.realtime
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js